import Vue from 'vue'
import VueRouter from 'vue-router'
Vue.use(VueRouter)
const routes=[
  {
    path: '/',
    name:'Layout',
    component:() => import('../layout.vue'),
    redirect:{name:'index'},
    children:[
      {
        path:"/index",
        name:"index",
        // meta:{bread:[""]},
        component: () => import('../views/index/index.vue')
      },
      {
        path:"/blank",
        name:"blank",
        component: () => import('../views/index/blank.vue')
      },
      {
        path:"/report",
        name:"report",
        meta:{bread:["报表统计"]},
        component: () => import('../views/report/index.vue')
      },
      {
        path:"/myUser",
        name:"myUser",
        meta:{bread:["用户信息"]},
        component: () => import('../views/myUser/index.vue')
      },
      {
        path:"/myUser/myUserDetail",
        name:"myUser_detail",
        meta:{bread:["用户信息","用户详情"]},
        component: () => import('../views/myUserDetail/index.vue'),
      },
      {
        path:"/orderInfo/orderServe",
        name:"orderInfo_order_serve",
        meta:{bread:["订单信息","服务订单"]},
        component: () => import('../views/orderInfo/serve/index.vue'),
      },
      {
        path:"/orderInfo/orderProduct",
        name:"orderInfo_order_product",
        meta:{bread:["订单信息","商品订单"]},
        component: () => import('../views/orderInfo/commodity/index.vue'),
      },
      {
        path:"/orderInfo/orderServeDetail",
        name:"orderInfo_order_serve_detail",
        meta:{bread:["订单信息","订单详情"]},
        component: () => import('../components/orderDetail.vue'),
      },
      {
        path:"/merchantManagement",
        name:"merchant_management",
        meta:{bread:["商户管理"]},
        component: () => import('../views/merchant/index.vue'),
      },
    ]
  },
  {
    path: '/Login',
    name: 'Login',
    component: () => import('../login.vue')
  },
]
const router = new VueRouter({
  routes
})
// 路由拦截
router.beforeEach((to,from,next) =>{
    next()
})
export default router




// WEBPACK FOOTER //
// ./src/router/index.js